import { Observable } from 'rxjs';

import { EFFECT } from './constants';

export function createEffect<T>(source: () => Observable<T> | void) {
  Object.defineProperty(source, EFFECT, { value: true });

  return source;
}
